<nav class="navbar navbar-expand-md top-navbar sticky-top" *ngIf="isVisible">
  <div class="container-fluid">
    <button class="navbar-toggler" type="button" (click)="isNavBarCollapsed = !isNavBarCollapsed">
      <span class="far fa-bars"></span>
    </button>
    <div [collapse]="isNavBarCollapsed" class="w-100">
      <div class="collapse navbar-collapse d-flex justify-content-between">
        <app-search *ngxPermissionsOnly="['canUseSearch']"></app-search>
        <button
          *ngxPermissionsOnly="['canUseSearch']"
          (click)="onOpenInventory()"
          matTooltip="Find available rentals within a date range"
          matTooltipClass="text-center"
          matTooltipPosition="below"
          type="button"
          class="inventory-btn"
        >
          <i class="fas fa-hotel"></i>
        </button>
        <div class="">
          <ul class="navbar-nav nav justify-content-center nav-center">
            <li *ngxPermissionsOnly="['canSeeDashboard']" routerLinkActive="active">
              <a routerLink="/dashboard">
                <i class="fal fa-tachometer-alt"></i>
                <span>Dashboard</span>
              </a>
            </li>
            <li *ngxPermissionsOnly="['canSeeRates']" routerLinkActive="active">
              <a routerLink="/rates">
                <i class="fal fa-donate"></i>
                <span>Rates</span>
              </a>
            </li>
            <li *ngxPermissionsOnly="['canSeeRentals']" routerLinkActive="active">
              <a routerLink="/rentals">
                <i class="fal fa-home"></i>
                <span>Rentals</span>
              </a>
            </li>
            <li *ngxPermissionsOnly="['canSeeChannels']" routerLinkActive="active">
              <a routerLink="/channels">
                <i class="fal fa-share-alt"></i>
                <span>Channels</span>
              </a>
            </li>
            <ng-container *ngxPermissionsOnly="['canSeeAddons']">
              <li dropdown container="body" placement="bottom right" class="dropdown">
                <button dropdownToggle type="button">
                  <i class="fal fa-plus-hexagon"></i>
                  <span>Add Ons</span>
                </button>
                <ul *dropdownMenu class="dropdown-menu dropdown-menu-right addons-dropdown">
                  <li
                    *ngIf="canSee('webready')"
                    (mouseenter)="websiteWidgetMenu.hide()"
                    [class.inactiveAddon]="isWebreadyInactive$ | async"
                  >
                    <a [href]="webreadyUrl()" target="_blank">
                      <div class="icon-holder">
                        <img class="rategenie-icon" src="//cdn.tokeet.com/images/Appstore_logos/webready.svg" alt="" />
                      </div>
                      <h5 class="title">Webready</h5>
                      <p>Create a beautiful website</p>
                    </a>
                  </li>
                  <li
                    *ngIf="canSee('power_reporting')"
                    (mouseenter)="websiteWidgetMenu.hide()"
                    [class.inactiveAddon]="isPowerReportingInactive$ | async"
                  >
                    <a [href]="powerReportingUrl()" target="_blank">
                      <div class="icon-holder">
                        <img class="rategenie-icon" src="assets/integrations/rental-ninja-logo.svg" alt="" />
                      </div>
                      <h5 class="title">Power Reporting</h5>
                      <p>Reporting tool</p>
                    </a>
                  </li>
                  <li
                    *ngIf="canSee('rategenie')"
                    (mouseenter)="websiteWidgetMenu.hide()"
                    [class.inactiveAddon]="isRateGenieInactive$ | async"
                  >
                    <a [href]="rategenieUrl()" target="_blank">
                      <div class="icon-holder">
                        <img class="rategenie-icon" src="//cdn.tokeet.com/icons/rategenie_icon.png" alt="" />
                      </div>
                      <h5 class="title">Rategenie</h5>
                      <p>Optimize your rates and revenue.</p>
                    </a>
                  </li>
                  <li
                    *ngIf="canSee('automata')"
                    (mouseenter)="websiteWidgetMenu.hide()"
                    [class.inactiveAddon]="isAutomataInactive$ | async"
                  >
                    <a [href]="automataUrl()" target="_blank">
                      <div class="icon-holder">
                        <img class="automata-icon" src="//cdn.tokeet.com/icons/automata_icon.png" alt="" />
                      </div>
                      <h5 class="title">Automata</h5>
                      <p>Automate your Tokeet workflows.</p>
                    </a>
                  </li>
                  <li
                    *ngIf="canSee('signature')"
                    (mouseenter)="websiteWidgetMenu.hide()"
                    [class.inactiveAddon]="isSignatureInactive$ | async"
                  >
                    <a [href]="signatureUrl()" target="_blank">
                      <div class="icon-holder">
                        <img src="../assets/images/icons/signature-icon.png" alt="" />
                      </div>
                      <h5 class="title">Signature</h5>
                      <p>Send contracts, forms, and documents.</p>
                    </a>
                  </li>
                  <li
                    *ngIf="canSee('checklist')"
                    (mouseenter)="websiteWidgetMenu.hide()"
                    [class.inactiveAddon]="isChecklistInactive$ | async"
                  >
                    <a [href]="checklistUrl()" target="_blank">
                      <div class="icon-holder">
                        <img src="https://cdn.tokeet.com/images/Appstore_logos/checklist.svg" alt="" />
                      </div>
                      <h5 class="title">Checklist</h5>
                      <p>Automate your property operations and maintenance</p>
                    </a>
                  </li>
                  <li *ngxPermissionsOnly="['canSeeReports']" (mouseenter)="websiteWidgetMenu.hide()">
                    <a [href]="reportsUrl()" target="_blank">
                      <div class="icon-holder">
                        <img src="../assets/images/icons/margins-icon.png" alt="" />
                      </div>
                      <h5 class="title">Margins</h5>
                      <p>Reporting application for the entire Tokeet platform.</p>
                    </a>
                  </li>
                  <ng-container *ngIf="canSee('ownercenter')">
                    <li *ngxPermissionsOnly="['canSeeOwnerCenter']" (mouseenter)="websiteWidgetMenu.hide()">
                      <a [href]="ownerCenterUrl()" target="_blank">
                        <div class="icon-holder">
                          <img src="../assets/images/icons/owners-icon.png" alt="" />
                        </div>
                        <h5 class="title">Owner Center</h5>
                        <p>Manage owners and send owner invoices and statements.</p>
                      </a>
                    </li>
                  </ng-container>
                  <li
                    *ngxPermissionsOnly="['canSeeWebsites', 'canSeeWidgets']"
                    dropdown
                    #websiteWidgetMenu="bs-dropdown"
                    triggers="mouseenter"
                    placement="right"
                    container="body"
                  >
                    <a routerLink="/websites" dropdownToggle class="d-flex align-items-center">
                      <div>
                        <div class="icon-holder">
                          <img src="../assets/images/icons/website-icon.png" alt="" />
                        </div>
                        <h5 class="title">Websites & Widgets</h5>
                        <p>Create a beautiful website or extend your current websites with Tokeet widgets.</p>
                      </div>
                      <i class="far fa-angle-right"></i>
                    </a>
                    <ul *dropdownMenu class="dropdown-menu addons-dropdown no-caret">
                      <li role="menuitem" *ngxPermissionsOnly="['canSeeWebsites']">
                        <a class="" routerLink="/websites">
                          <div class="icon-holder">
                            <i class="fal fa-globe"></i>
                          </div>
                          <h5 class="title">Websites</h5>
                          <p>Create and manage websites and booking engines.</p>
                        </a>
                      </li>
                      <li role="menuitem" *ngxPermissionsOnly="['canSeeWidgets']">
                        <a class="" routerLink="/widgets">
                          <div class="icon-holder">
                            <i class="fal fa-layer-plus"></i>
                          </div>
                          <h5 class="title">Widgets</h5>
                          <p>Setup your Tokeet calendar, inquiry, and other widgets.</p>
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ng-container>

            <li *ngxPermissionsOnly="['canSeeAppStore']" routerLinkActive="active">
              <a [href]="appStoreUrl()" (click)="onVisitAppStore()" target="_blank">
                <i class="fal fa-store"></i>
                <span>App Store</span>
              </a>
            </li>

            <ng-container *ngxPermissionsOnly="['canSeeSettings']">
              <li
                dropdown
                container="body"
                placement="bottom right"
                class="dropdown"
                [ngClass]="{
                  active:
                    utility.isRouteActive('settings') ||
                    utility.isRouteActive('payments') ||
                    utility.isRouteActive('sharing') ||
                    utility.isRouteActive('billing') ||
                    utility.isRouteActive('templates') ||
                    utility.isRouteActive('integrations') ||
                    utility.isRouteActive('feeds')
                }"
              >
                <button dropdownToggle type="button">
                  <i class="fal fa-cog"></i>
                  <span>Settings</span>
                </button>
                <ul *dropdownMenu class="dropdown-menu wide-dropdown-menu dropdown-menu-right">
                  <li class="clearfix">
                    <a routerLink="/settings/user-settings">
                      <div class="icon-holder">
                        <i class="fal fa-users-cog"></i>
                      </div>
                      <h5 class="title">User Settings</h5>
                      <p>Create and manage users, update their passwords, and set their user type.</p>
                    </a>
                    <a routerLink="/settings/email">
                      <div class="icon-holder">
                        <i class="fal fa-envelope"></i>
                      </div>
                      <h5 class="title">Email Options</h5>
                      <p>Configure automated email forwarding.</p>
                    </a>
                    <a routerLink="/settings/branding">
                      <div class="icon-holder">
                        <i class="fal fa-paint-brush"></i>
                      </div>
                      <h5 class="title">Branding Info</h5>
                      <p>Customize Tokeet to match your company look and feel.</p>
                    </a>
                    <a routerLink="/settings/files">
                      <div class="icon-holder">
                        <i class="fal fa-folder-open"></i>
                      </div>
                      <h5 class="title">File Cabinet</h5>
                      <p>Upload and save files that every user may access.</p>
                    </a>
                    <a *ngxPermissionsOnly="['canSeePayments']" routerLink="/payments">
                      <div class="icon-holder">
                        <i class="fal fa-credit-card"></i>
                      </div>
                      <h5 class="title">Payments</h5>
                      <p>Allow users to pay you online and process credit cards.</p>
                    </a>
                    <a *ngxPermissionsOnly="['canSeeDataFeeds']" routerLink="/feeds">
                      <div class="icon-holder">
                        <i class="fal fa-cloud-download"></i>
                      </div>
                      <h5 class="title">Data Feeds</h5>
                      <p>Extract data from Tokeet with a single, secure URL.</p>
                    </a>
                    <a *ngxPermissionsOnly="['canSeeSharing']" routerLink="/sharing">
                      <div class="icon-holder">
                        <i class="fal fa-share"></i>
                      </div>
                      <h5 class="title">Shared Content</h5>
                      <p>Share your calendars and other content via URL.</p>
                    </a>
                    <a *ngxPermissionsOnly="['canSeeTemplates']" routerLink="/templates">
                      <div class="icon-holder">
                        <i class="fal fa-file-alt"></i>
                      </div>
                      <h5 class="title">Templates</h5>
                      <p>Create message templates to automatically send to users and guests.</p>
                    </a>
                    <a *ngxPermissionsOnly="['canSeeIntegrations']" routerLink="/integrations">
                      <div class="icon-holder">
                        <i class="fal fa-cubes"></i>
                      </div>
                      <h5 class="title">Integrations</h5>
                      <p>Configure third-party integrations like MailChimp.</p>
                    </a>
                    <a *ngxPermissionsOnly="['canSeeAutomations']" routerLink="/automations">
                      <div class="icon-holder">
                        <span class="icon-with-addon">
                          <i class="icon fal fa-bell"></i>
                          <i class="icon-addon fal fa-cog"></i>
                        </span>
                      </div>
                      <h5 class="title">Automations</h5>
                      <p>Automate your guest and user messaging.</p>
                    </a>
                    <a *ngxPermissionsOnly="['canSeeStealth']" routerLink="/stealth">
                      <div class="icon-holder">
                        <i class="icon fal fa-user-secret"></i>
                      </div>
                      <h5 class="title">Stealth</h5>
                      <p>Stealth mode unlists your Airbnb rental during specific hours of the day.</p>
                    </a>
                    <ng-container *ngIf="aiResponderSub$ | async as aiResponderSub">
                      <a
                        *ngxPermissionsOnly="['canSeeAISettings']"
                        (click)="onAISettings(aiResponderSub.isValid)"
                        [ngStyle]="!aiResponderSub?.isValid ? { filter: 'grayscale(1)', opacity: '0.9' } : {}"
                        [matTooltip]="aiResponderSub?.isValid ? '' : 'Go to Appstore to subscribe for this'"
                      >
                        <div class="icon-holder">
                          <svg-icon src="assets/images/icons/ai.svg" [svgStyle]="{ 'width.px': 25 }"></svg-icon>
                        </div>
                        <h5 class="title">AI Settings</h5>
                        <p>Automatic bot response and feed data to the bot.</p>
                      </a>
                    </ng-container>
                  </li>
                </ul>
              </li>
            </ng-container>
          </ul>
        </div>
        <div class="">
          <ul class="navbar-nav nav-right nav justify-content-end">
            <li *ngxPermissionsOnly="['canSeeNotifications']" class="notification-holder d-none d-lg-inline-block">
              <app-notifications></app-notifications>
            </li>
            <li *ngxPermissionsOnly="['canSeeInquiries']" class="notification-holder d-none d-lg-inline-block">
              <app-messages-icon></app-messages-icon>
            </li>
            <li dropdown class="dropdown">
              <a dropdownToggle role="button" class="username">
                <span [matTooltip]="name" matTooltipPosition="below" matTooltipClass="text-center" class="name">{{
                  name | truncate : 30
                }}</span>
                <br />
                <span class="role">{{ role }}</span>
                <i class="far dropdown-icon fa-angle-down"></i>
              </a>
              <ul *dropdownMenu class="dropdown-menu dropdown-menu-right user-dropdown-menu">
                <li *ngxPermissionsOnly="['canSeeAccount']">
                  <a
                    matTooltip="Manage your account preferences, company details, and domain name."
                    matTooltipClass="text-center"
                    matTooltipPosition="left"
                    routerLink="/account"
                    ><i class="fal fa-building"></i> Account Info
                  </a>
                </li>
                <li *ngxPermissionsOnly="['canChangePassword']">
                  <a
                    matTooltip="Change your password."
                    matTooltipClass="text-center"
                    matTooltipPosition="left"
                    (click)="onChangePassword()"
                    ><i class="fal fa-key"></i> Change Password
                  </a>
                </li>
                <li>
                  <a
                    matTooltip="Configure MFA."
                    matTooltipClass="text-center"
                    matTooltipPosition="left"
                    (click)="onMFA()"
                    ><i class="fal fa-cog"></i> Configure MFA
                  </a>
                </li>
                <li *ngxPermissionsOnly="['canSeeBilling']">
                  <a
                    matTooltip="Manage your subscription, payment details, and view your billing history."
                    matTooltipClass="text-center"
                    matTooltipPosition="left"
                    routerLink="/billing/info"
                    ><i class="fal fa-file-invoice-dollar"></i> Billing Info
                  </a>
                </li>
                <li *ngxPermissionsOnly="['canSeeChangelog']">
                  <a
                    matTooltip="Stay updated about changes and new features in Tokeet."
                    matTooltipClass="text-center"
                    matTooltipPosition="left"
                    href="https://changes.tokeet.com/"
                    target="_blank"
                    ><i class="fal fa-podcast"></i> Tokeet Changelog
                  </a>
                </li>
                <li *ngxPermissionsOnly="['canSeeChangelog']" role="separator" class="dropdown-divider"></li>
                <li>
                  <a (click)="logout()" role="link"><i class="fal fa-sign-out"></i> Logout</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</nav>
